import { API } from '../../../../config';
import { errorHandler } from '../../auth/errorAction';

export const unmountListLanguageSkills = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_LANGUAGE_SKILLS'})
}

export const unmountDetailLanguageSkills = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_LANGUAGE_SKILLS'})
}

export const unmountMasterLanguageSkills = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_LANGUAGE_SKILLS'})
}

export const listLanguageSkills = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_LANGUAGE_SKILLS' })
  return API.GET('/language_level/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_LANGUAGE_SKILLS_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_LANGUAGE_SKILLS_FAILED' }), 
    ))
  })
}

export const detailLanguageSkills = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_LANGUAGE_SKILLS' })
  const params = {
    'id': id
  }
  API.GET('/language_level/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_LANGUAGE_SKILLS_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_LANGUAGE_SKILLS_FAILED' }), 
      ))
    )
  })
}

export const masterLanguageSkills = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_LANGUAGE_SKILLS' })
  return API.GET('/language_level/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_LANGUAGE_SKILLS_SUCCESS', 
      payload: { data: response.data }
    })
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_LANGUAGE_SKILLS_FAILED' }), 
    ))
  })
}

export const createLanguageSkills = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/language_level/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const updateLanguageSkills = (value, successCB, failedCB) => () => {
  API.POST_NO_PARAMS('/language_level/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableLanguageSkills = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/language_level/enable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableLanguageSkills = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/language_level/disable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}